export default __webpack_public_path__ + "static/media/highestBid.d6e0f9f1.svg";